/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Link, Routes, Outlet } from "react-router-dom";
import { Error500 } from "./components/Error500";
import { Error404 } from "./components/Error404";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { Footer } from "_metronic/layout/components/Footer";
import { Error403 } from "./components/Error403";
import getAbsoluteLogoURL from "global/helpers";

const ErrorsLayout = () => {
  return (
    <div className="d-flex flex-column flex-root">
      <div
        className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
        style={{
          backgroundImage: `url('${toAbsoluteUrl("/media/illustrations/progress-hd.png")}')`,
        }}
      >
        <div className="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20">
          <a data-test-id="error-page__logo-link" href="/dashboard" className="mb-10 pt-lg-20">
            <img alt="Logo" src={getAbsoluteLogoURL()} className="proptimo-logo-large mb-5" />
          </a>
          <div className="pt-lg-10 mb-10">
            <Outlet />
            <div className="text-center">
              <Link data-test-id="error-page__go-to-homepage-link" to="/" className="btn btn-lg btn-primary">
                Go to homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path="403" element={<Error403 />} />
      <Route path="404" element={<Error404 />} />
      <Route path="500" element={<Error500 />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
);

export { ErrorsPage };
